import { DISEASE } from 'utils/constants/disease';

export const getQuestions = async (condition) => {
  let questions;
  switch (condition) {
    case DISEASE.MELANOMA_2:
      ({ default: questions } = await import('./melanoma_2/questions'));
      break;
    case DISEASE.MDS:
      ({ default: questions } = await import('./mds/questions'));
      break;
    case DISEASE.MPN:
      ({ default: questions } = await import('./mpn/questions'));
      break;
    case DISEASE.UTERINE:
      ({ default: questions } = await import('./uterine/questions'));
      break;
    case DISEASE.BRAIN:
      ({ default: questions } = await import('./brain/questions'));
      break;
    case DISEASE.MM:
      ({ default: questions } = await import('./mm/questions'));
      break;
    case DISEASE.LUNG:
      ({ default: questions } = await import('./lung/questions'));
      break;
    case DISEASE.BREAST_2:
      ({ default: questions } = await import('./breast_2/questions'));
      break;
    case DISEASE.NHL:
      ({ default: questions } = await import('./nhl/questions'));
      break;
    case DISEASE.CRC_2:
      ({ default: questions } = await import('./crc_2/questions'));
      break;
    case DISEASE.PROSTATE:
      ({ default: questions } = await import('./prostate/questions'));
      break;
    case DISEASE.AML:
      ({ default: questions } = await import('./aml/questions'));
      break;
    case DISEASE.HNSCC:
      ({ default: questions } = await import('./hnscc/questions'));
      break;
    case DISEASE.BLADDER_2:
      ({ default: questions } = await import('./bladder_2/questions'));
      break;
    case DISEASE.CLL:
      ({ default: questions } = await import('./cll/questions'));
      break;
    case DISEASE.GI_TRACT:
      ({ default: questions } = await import('./gi_tract/questions'));
      break;
    case DISEASE.OVARIAN:
      ({ default: questions } = await import('./ovarian/questions'));
      break;
    case DISEASE.HCC:
      ({ default: questions } = await import('./hcc/questions'));
      break;
    default:
      questions = null;
  }
  return questions;
};
